import React from "react"
import { Box, Stack, Typography, useMediaQuery } from "@mui/material"
import { Link } from "react-router-dom"
import { format, splitAlbumName } from "../text-helper/text-helper";
import { LastFmPlaylistItem } from "../../types/LastFmPlaylist";

type TrackDisplayProps = {
    track: LastFmPlaylistItem | undefined;
};

const TrackDisplay = ({ track }: TrackDisplayProps) => {
    const isLessThan1000 = useMediaQuery('(max-width:1000px)');

    return (
        <Stack direction={isLessThan1000 ? 'column' : 'row'} spacing={0.5}>
            {isLessThan1000 ?
                <>
                    <Box>
                        <Typography variant="body1" sx={{ wordWrap: 'nowrap' }}>
                            by&nbsp;
                            <Link to={`/letters/${track?.letter}/artists/${track?.artist}`}>
                                {format(track?.artist ?? '')}
                            </Link> {!isLessThan1000 && <>-</>}
                        </Typography>
                    </Box>
                    <Box>
                        <Typography variant="body1">
                            {splitAlbumName(track?.album ?? '-').year} {!isLessThan1000 && <>-</>}
                        </Typography>
                    </Box>
                    <Box>
                        <Typography variant="body1" sx={{ wordWrap: 'nowrap' }}>
                            <Link to={`/letters/${track?.letter}/artists/${track?.artist}/albums/${track?.album}`}>
                                {splitAlbumName(track?.album ?? '-').title}
                            </Link>
                        </Typography>
                    </Box>
                </>
                :
                <>
                    <Box>                                                
                        by&nbsp;
                        <Link to={`/letters/${track?.letter}/artists/${track?.artist}`}>
                            {format(track?.artist ?? '')}
                        </Link> - {splitAlbumName(track?.album ?? '-').year} - <Link to={`/letters/${track?.letter}/artists/${track?.artist}/albums/${track?.album}`}>
                            {splitAlbumName(track?.album ?? '-').title}
                        </Link>
                    </Box>
                </>
            }
        </Stack>
    );
}

export default TrackDisplay;